import {AfterViewInit, Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {PopoverConfig, PopoverDirective} from 'ngx-bootstrap/popover';

@Component({
    selector: 'app-comment-box',
    templateUrl: './comment-box.component.html',
    styleUrls: ['./comment-box.component.scss'],
    standalone: false
})
export class CommentBoxComponent implements OnInit, AfterViewInit {
  @ViewChildren(PopoverDirective) popovers: QueryList<PopoverDirective>;
  @Input() commentFormController: UntypedFormControl;
  @Input() bsPopover: PopoverDirective;

  editMode = false;

  constructor() {
  }

  ngOnInit(): void {
    this.editMode = !this.commentFormController.value;
  }

  ngAfterViewInit() {
    this.closeAllPopoverWindow(this.popovers);
  }

  closeAllPopoverWindow(popovers: QueryList<PopoverDirective>) {
    popovers.forEach((popover: PopoverDirective) => {
      popover.onShown.subscribe(() => {
        popovers
          .filter(p => p !== popover)
          .forEach(p => p.hide());
      });
    });
  }

  closePopover() {
    this.bsPopover.hide();
  }

  deleteComment() {
    this.commentFormController.setValue('');
    this.commentFormController.markAsDirty();
    this.closePopover();
  }
}

export function getPopoverConfig(): PopoverConfig {
  return Object.assign(new PopoverConfig(), {
    placement: 'bottom',
    container: 'body',
    outsideClick: true
  });
}
